var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<li class="profile-cal__time-item ' +
__e( event.patientGroupClasses.join(' ') ) +
'" data-event-id="' +
__e( event.id ) +
'" data-event-practitioner-ids="' +
__e( event.practitionerIds.join(',') ) +
'" data-event-class="' +
__e( event.class ) +
'" data-event-date="' +
__e( event.date ) +
'" data-event-time="' +
__e( event.time ) +
'" data-event-duration="' +
__e( event.duration ) +
'" data-event-start="' +
__e( event.start ) +
'" data-event-end="' +
__e( event.end ) +
'" data-event-reservations-allowed="' +
__e( event.reservationsAllowed ) +
'" data-event-external-diary="' +
__e( event.externalDiary ) +
'" data-event-auto-accept="' +
__e( Number(event.autoAccept) ) +
'"> ' +
__e( event.title ) +
' ';
 $.each(event.patientGroups, function (index, patientGroup) { ;
__p += ' <span class="profile-cal__time-item__patient-group" data-id="' +
__e( patientGroup.id ) +
'" data-name="' +
__e( patientGroup.name ) +
'"></span> ';
 }); ;
__p += '</li>';

}
return __p
};

/*
original source:

<li class="profile-cal__time-item <%- event.patientGroupClasses.join(' ') %>"
    data-event-id="<%- event.id %>"
    data-event-practitioner-ids="<%- event.practitionerIds.join(',') %>"
    data-event-class="<%- event.class %>"
    data-event-date="<%- event.date %>"
    data-event-time="<%- event.time %>"
    data-event-duration="<%- event.duration %>"
    data-event-start="<%- event.start %>"
    data-event-end="<%- event.end %>"
    data-event-reservations-allowed="<%- event.reservationsAllowed %>"
    data-event-external-diary="<%- event.externalDiary %>"
    data-event-auto-accept="<%- Number(event.autoAccept) %>">
        <%- event.title %>
        <% $.each(event.patientGroups, function (index, patientGroup) { %>
            <span class="profile-cal__time-item__patient-group"
                  data-id="<%- patientGroup.id %>"
                  data-name="<%- patientGroup.name %>"></span>
        <% }); %>

*/
